'use client';

import { CloudUpload, BrainCircuit, MessageSquare } from 'lucide-react';
import { Display, Headline, Label, Reveal, GlassCard } from '../ui';

// Copy kept accurate to the product: Reclipt transcribes audio and tags moments
// from the transcript (it is not a visual/multimodal indexer).
const steps = [
  {
    n: '01',
    icon: CloudUpload,
    title: 'Upload & Ingest',
    desc: 'Drop your archive into the pipeline. We handle massive libraries without breaking a sweat.',
  },
  {
    n: '02',
    icon: BrainCircuit,
    title: 'AI Analysis',
    desc: 'We transcribe every word and tag every moment (topics, outcomes and subjects) so nothing stays buried.',
  },
  {
    n: '03',
    icon: MessageSquare,
    title: 'Chat to Find',
    desc: 'Type what you need, get the clip instantly. No more manual scrubbing or endless folders.',
  },
];

export default function WorkflowSection() {
  return (
    <section id="workflow" className="mx-auto max-w-[1280px] px-6 py-28">
      <Reveal className="mb-16 text-center">
        <Label className="mb-4">Workflow</Label>
        <Headline className="mb-4 text-4xl sm:text-5xl">
          See exactly how Reclipt works.
        </Headline>
        <p className="mx-auto max-w-xl font-mk-body text-mk-muted">
          From raw upload to the perfect clip in under 60 seconds.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <GlassCard hover className="group h-full p-10 hover:border-mk-pink/50">
              <div className="mb-6 font-mk-display text-5xl text-mk-pink opacity-20 transition-opacity group-hover:opacity-100">
                {s.n}
              </div>
              <Headline as="h3" className="mb-4 text-2xl">
                {s.title}
              </Headline>
              <p className="font-mk-body text-mk-muted">{s.desc}</p>
              <div className="mt-8 flex justify-center">
                <s.icon className="h-14 w-14 text-mk-pink" strokeWidth={1.2} />
              </div>
            </GlassCard>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
